module.exports = __webpack_public_path__ + "img/5.7b99afa3.jpg";